var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 9.58581L22.4143 4C22.2285 3.81427 22.0081 3.66695 21.7654 3.56643C21.5228 3.46592 21.2627 3.41418 21 3.41418C20.7374 3.41418 20.4773 3.46592 20.2347 3.56643C19.992 3.66695 19.7715 3.81427 19.5858 4L16.2931 7.29272L4.58588 18.9999C4.39956 19.1852 4.25184 19.4056 4.15127 19.6484C4.0507 19.8911 3.99929 20.1514 4.00001 20.4142V26C4.00061 26.5302 4.21152 27.0386 4.58646 27.4135C4.96141 27.7885 5.46976 27.9994 6.00001 28H11.5858C11.8486 28.0007 12.1089 27.9493 12.3516 27.8488C12.5943 27.7482 12.8147 27.6005 13 27.4142L28.0001 12.4142C28.3746 12.0388 28.5849 11.5302 28.5849 11C28.5848 10.4698 28.3745 9.96117 28 9.58581Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSimple);
export default __webpack_public_path__ + "static/media/PencilSimple.0a3ed3c8.svg";
export { ForwardRef as ReactComponent };